<template>
  <div class="onLine">
    <div class="container-fluid t-head border-bottom">
      <ul class="row p-0 navy font-weight-bold">
        <li class="col-2 col-lg-1">#</li>
        <li class="col pl-0 pl-lg-3">姓名/電話</li>
        <li class="col d-none d-lg-block">時間</li>
        <li class="col d-none d-lg-block">人數</li>
        <li class="col col-sm-3 d-block d-lg-none">時間/人數</li>
        <li class="col-4 col-lg-4 pl-0 pl-sm-2">狀態</li>
      </ul>
    </div>
    <div class="accordion t-body" id="accordionList">
      <div
        class="card OnLineItem navy"
        v-for="(item, index) in list"
        :key="item.Id"
        :class="[{'beLateColor':item.NotYetAttend},{'check':item.Attend}]"
      >
        <div class="card-header" :id="'item'+item.Id">
          <div class="row">
            <div
              class="col-8 collapsed"
              data-toggle="collapse"
              :data-target="'#note'+item.Id"
              aria-expanded="true"
              :aria-controls="'note'+item.Id"
            >
              <ul class="row p-0 my-2">
                <li class="col-3 col-lg-2">{{ item.OrderNumber }}</li>
                <li class="col pl-0">
                  <p class="h5 m-0">
                    {{ item.CustomerName }}
                    <span>{{ item.CustomerGender }}</span>
                  </p>
                  <small
                    class="text-muted"
                    :class="[{'beLateColor':item.NotYetAttend},{'check':item.Attend}]"
                  >{{ item.CustomerPhone }}</small>
                </li>
                <li class="col d-none d-lg-block h2">{{ item.OrderDate.substr(11,5) }}</li>
                <li class="col d-none d-lg-flex">
                  <p class="h1 m-0">{{ item.OrderAdultPeople }}</p>
                  <p class="h5 m-0" v-if="item.OrderChildrenPeople!=0">
                    <i class="las la-child"></i>
                    <span>{{ item.OrderChildrenPeople }}</span>
                  </p>
                  <p class="h5 m-0" v-if="item.OrderBabyPeople!=0">
                    <i class="las la-baby-carriage"></i>
                    <span>{{ item.OrderBabyPeople }}</span>
                  </p>
                </li>
                <li class="col d-block d-lg-none">
                  <div class="h4">{{ item.OrderDate.substr(11,5) }}</div>
                  <div class="d-flex">
                    <small class="h4 m-0">{{ item.OrderAdultPeople }}</small>
                    <small class="h6 m-0" v-if="item.OrderChildrenPeople!=0">
                      <i class="las la-child"></i>
                      <span>{{ item.OrderChildrenPeople }}</span>
                    </small>
                    <small class="h6 m-0" v-if="item.OrderBabyPeople!=0">
                      <i class="las la-baby-carriage"></i>
                      <span>{{ item.OrderBabyPeople }}</span>
                    </small>
                  </div>
                </li>
              </ul>
            </div>
            <div class="col-4 p-0">
              <div class="d-flex justify-content-around align-items-center h2 m-0 h-100">
                <i class="las la-check-double" :class="{'d-none':!item.Attend}" @click="goIn(item)"></i>
                <i
                  class="las la-check-circle"
                  :class="[{'d-none':item.NotYetAttend},{'d-none':item.Attend}]"
                  @click="check(item)"
                ></i>
                <i class="las la-history" @click="beLate(item)"></i>
                <i class="lar la-times-circle" @click="del (item, index)"></i>
                <i
                  class="lar la-edit"
                  data-toggle="collapse"
                  :data-target="'#edit'+item.Id"
                  aria-expanded="true"
                  :aria-controls="'edit'+item.Id"
                  @click="editUserData(item)"
                  :class="{'d-none':item.NotYetAttend}"
                ></i>
              </div>
            </div>
          </div>
        </div>
        <div
          :id="'note'+item.Id"
          class="collapse"
          :aria-labelledby="'item'+item.Id"
          data-parent="#accordionList"
        >
          <div class="card-body">
            <div class="row">
              <div class="col">
                <i class="las la-2x la-user"></i>
                <i class="las la-1x la-hand-point-right"></i>
                {{ item.CustomerNote }}
              </div>
              <div class="col">
                <i class="las la-2x la-user-astronaut"></i>
                <i class="las la-1x la-hand-point-right"></i>
                {{ item.BusinessNote }}
              </div>
            </div>
          </div>
        </div>
        <div
          :id="'edit'+item.Id"
          class="collapse"
          :aria-labelledby="'item'+item.Id"
          data-parent="#accordionList"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-6 col-lg-2 col-xl-1 mb-3 mb-xl-0">
                <label class="d-flex">
                  <i class="las la-2x la-id-badge"></i>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    :placeholder="item.OrderNumber"
                    v-model="editItem.OrderNumber"
                  />
                </label>
              </div>
              <div class="col-6 col-lg-4 col-xl mb-3 mb-xl-0">
                <label class="d-flex">
                  <i class="las la-2x la-history"></i>
                  <div class="form-row">
                    <div class="col">
                      <select class="custom-select custom-select-sm" v-model="editItem.OrderHour">
                        <option v-for="index in 25" :key="index" :value="index-1">{{ index-1 }}</option>
                      </select>
                    </div>
                    <div class="col">
                      <select class="custom-select custom-select-sm" v-model="editItem.OrderMinute">
                        <option v-for="index in 60" :key="index" :value="index-1">{{ index-1 }}</option>
                      </select>
                    </div>
                  </div>
                </label>
              </div>
              <div class="col-6 col-lg-3 col-xl mb-3 mb-xl-0">
                <label class="d-flex">
                  <i class="las la-2x la-user"></i>
                  <select
                    class="custom-select custom-select-sm"
                    v-model="editItem.OrderAdultPeople"
                  >
                    <option v-for="index in 100" :key="index" :value="index-1">{{ index-1 }}</option>
                  </select>
                </label>
              </div>
              <div class="col-6 col-lg-3 col-xl mb-3 mb-sm-0">
                <label class="d-flex">
                  <i class="las la-2x la-child"></i>
                  <select
                    class="custom-select custom-select-sm"
                    v-model="editItem.OrderChildrenPeople"
                  >
                    <option v-for="index in 100" :key="index" :value="index-1">{{ index-1 }}</option>
                  </select>
                </label>
              </div>
              <div class="col-6 col-lg-3 col-xl mb-3 mb-sm-0">
                <label class="d-flex">
                  <i class="las la-2x la-baby-carriage"></i>
                  <select class="custom-select custom-select-sm" v-model="editItem.OrderBabyPeople">
                    <option v-for="index in 100" :key="index" :value="index-1">{{ index-1 }}</option>
                  </select>
                </label>
              </div>
              <div class="col-6 col-lg-3 col-xl-3">
                <label class="d-flex" for="exampleFormControlTextarea1">
                  <i class="las la-2x la-comment-medical"></i>
                  <textarea
                    class="form-control"
                    id="exampleFormControlTextarea1"
                    rows="1"
                    :placeholder="item.BusinessNote"
                    v-model="editItem.BusinessNote"
                  ></textarea>
                </label>
              </div>
              <div class="col-6 col-lg-3 col-xl-1">
                <button
                  type="button"
                  class="btn btn-outline-dark btn-sm"
                  @click="sendEdit (item)"
                >修改</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      editItem: {
        id: '',
        RoleId: '',
        OrderHour: '',
        OrderMinute: '',
        OrderNumber: '',
        OrderAdultPeople: 0,
        OrderChildrenPeople: 0,
        OrderBabyPeople: 0,
        BusinessNote: ''
      }
    }
  },
  computed: {
    list () {
      return this.$store.state.AllBookInfo.NetWorkBookInfo
    }
  },
  methods: {
    editUserData (item) {
      this.editItem.id = item.Id
      this.editItem.OrderNumber = item.OrderNumber
      this.editItem.OrderHour = parseInt(item.OrderDate.substr(11, 2))
      this.editItem.OrderMinute = parseInt(item.OrderDate.substr(14, 2))
      this.editItem.OrderAdultPeople = item.OrderAdultPeople
      this.editItem.OrderChildrenPeople = item.OrderChildrenPeople
      this.editItem.OrderBabyPeople = item.OrderBabyPeople
    },
    sendEdit (item) {
      const vm = this
      const url = 'http://imrebooksystem.rocket-coding.com/Dashboard/EditNetWorkBook'
      const d = this.editItem
      const year = item.OrderDate.substr(0, 4)
      const month = item.OrderDate.substr(5, 2)
      const day = item.OrderDate.substr(8, 2)
      var data = {
        id: d.id,
        RoleId: '',
        OrderDate: `${year}/${month}/${day} ${d.OrderHour}:${d.OrderMinute}`,
        OrderNumber: d.OrderNumber,
        OrderAdultPeople: d.OrderAdultPeople,
        OrderChildrenPeople: d.OrderChildrenPeople,
        OrderBabyPeople: d.OrderBabyPeople,
        BusinessNote: d.BusinessNote
      }
      this.axios
        .post(url, data)
        .then(function (res) {
          if (res.data === '修改成功') {
            vm.$swal({
              position: 'top-end',
              background: '#F7ECEB',
              icon: 'success',
              title: '修改成功',
              showConfirmButton: false,
              toast: true,
              timer: 3000,
              timerProgressBar: true,
              onOpen: toast => {
                toast.addEventListener('mouseenter', vm.$swal.stopTimer)
                toast.addEventListener('mouseleave', vm.$swal.resumeTimer)
              }
            })
            vm.$store.dispatch('BusinessUser')
          } else {
            vm.$swal({
              position: 'top-end',
              background: '#F7ECEB',
              icon: 'error',
              title: res.data,
              showConfirmButton: false,
              toast: true,
              timer: 3000,
              timerProgressBar: true,
              onOpen: toast => {
                toast.addEventListener('mouseenter', vm.$swal.stopTimer)
                toast.addEventListener('mouseleave', vm.$swal.resumeTimer)
              }
            })
          }
        })
        .catch(error => console.error(error))
    },
    del (item, index) {
      const vm = this
      this.$swal({
        icon: 'warning',
        title: `是否刪除${item.CustomerName} ?`,
        text: '刪除後將無法還原!',
        showCancelButton: true,
        confirmButtonColor: '#B8817D',
        cancelButtonColor: '#545871',
        confirmButtonText: '是的,要刪除哦~'
      }).then(result => {
        if (result.value) {
          const url = 'http://imrebooksystem.rocket-coding.com/Dashboard/DeleteNetWorkBook'
          vm.axios
            .post(url, { Id: item.Id })
            .then(function (res) {
              if (res.data === '刪除成功') {
                var [...list] = vm.$store.state.AllBookInfo.NetWorkBookInfo
                list.splice(index, 1)
                vm.$store.commit('bookInfo', { NetWorkBookInfo: list })
                vm.$swal({
                  position: 'top-end',
                  background: '#F7ECEB',
                  icon: 'success',
                  title: '刪除成功',
                  showConfirmButton: false,
                  toast: true,
                  timer: 3000,
                  timerProgressBar: true,
                  onOpen: toast => {
                    toast.addEventListener('mouseenter', vm.$swal.stopTimer)
                    toast.addEventListener('mouseleave', vm.$swal.resumeTimer)
                  }
                })
              } else {
                vm.$swal({
                  position: 'top-end',
                  background: '#F7ECEB',
                  icon: 'error',
                  title: res.data,
                  showConfirmButton: false,
                  toast: true,
                  timer: 3000,
                  timerProgressBar: true,
                  onOpen: toast => {
                    toast.addEventListener('mouseenter', vm.$swal.stopTimer)
                    toast.addEventListener('mouseleave', vm.$swal.resumeTimer)
                  }
                })
              }
            })
            .catch(error => console.error(error))
        }
      })
    },
    beLate (item) {
      const vm = this
      const url = 'http://imrebooksystem.rocket-coding.com/Dashboard/NetWorkNotAttend'
      vm.axios
        .post(url, { id: item.Id, notAttend: true })
        .then(function (res) {
          vm.$swal({
            position: 'top-end',
            background: '#F7ECEB',
            icon: 'info',
            title: res.data,
            showConfirmButton: false,
            toast: true,
            timer: 3000,
            timerProgressBar: true,
            onOpen: toast => {
              toast.addEventListener('mouseenter', vm.$swal.stopTimer)
              toast.addEventListener('mouseleave', vm.$swal.resumeTimer)
            }
          })
          vm.$store.dispatch('BusinessUser')
        })
        .catch(error => console.error(error))
    },
    check (item) {
      const vm = this
      const url = 'http://imrebooksystem.rocket-coding.com/Dashboard/NetWorkAttend'
      vm.axios
        .post(url, { id: item.Id, attend: true })
        .then(function (res) {
          vm.$swal({
            position: 'top-end',
            background: '#F7ECEB',
            icon: 'success',
            title: res.data,
            showConfirmButton: false,
            toast: true,
            timer: 3000,
            timerProgressBar: true,
            onOpen: toast => {
              toast.addEventListener('mouseenter', vm.$swal.stopTimer)
              toast.addEventListener('mouseleave', vm.$swal.resumeTimer)
            }
          })
          vm.$store.dispatch('BusinessUser')
        })
        .catch(error => console.error(error))
    },
    goIn (item) {
      const vm = this
      const url = 'http://imrebooksystem.rocket-coding.com/Dashboard/NetWorkEnter'
      vm.axios
        .post(url, { id: item.Id, enter: true })
        .then(function (res) {
          vm.$swal({
            position: 'top-end',
            background: '#F7ECEB',
            icon: 'success',
            title: res.data,
            showConfirmButton: false,
            toast: true,
            timer: 3000,
            timerProgressBar: true,
            onOpen: toast => {
              toast.addEventListener('mouseenter', vm.$swal.stopTimer)
              toast.addEventListener('mouseleave', vm.$swal.resumeTimer)
            }
          })
          vm.$store.dispatch('BusinessUser')
        })
        .catch(error => console.error(error))
    }
  },
  created () {
    this.$store.dispatch('BusinessUser')
  }
}
</script>
<style lang="scss">
.onLine {
  width: 100%;
  overflow-x: auto;
}
.t-body {
  .OnLineItem {
    background-color: #f7eceb;
    border: 0;
    border-bottom: 1px solid #1872 !important;
    transition: 0.5s;
    .card-header {
      background-color: transparent;
    }
  }
  .OnLineItem:hover {
    background-color: rgba(255, 255, 255, 0.435);
    transition: 0.5s;
  }
}
@media (max-width: 576px) {
  .t-head,
  .t-body {
    width: 500px;
  }
}
</style>
